import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { PageCategoryService } from './page-category.service';
import { PageCategoryStore } from './page-category.store';
import { PageCategoryQuery } from './page-category.query';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppToken } from "../../../models/app-token";

@Injectable({ providedIn: 'root' })
export class PageCategoryFacade extends BaseFacade {

    constructor(
        pageCategoryService: PageCategoryService,
        pageCategoryStore: PageCategoryStore,
        pageCategoryQuery: PageCategoryQuery,
        dynamicSchemaFactory: DynamicSchemaFactory,
        translateService: TranslateService) {
        super(pageCategoryService,
          pageCategoryStore,
          pageCategoryQuery,
            dynamicSchemaFactory.getDynamicSchemaFacade(AppToken.PAGE_CATEGORY_SCHEMA_NAME),
          translateService,
          AppToken.PAGE_CATEGORY_SCHEMA_NAME + '-facade'
          );
    }

}
